(() => {
  const root = window.Shopify?.routes?.root || '/';
  let adding = false;
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-pairing-variant]');
    if (!select) return;
    const card = select.closest('[data-atwill-pairing-card]');
    card.querySelector('[data-pairing-add]').disabled = !select.value;
    const price = select.selectedOptions[0]?.dataset.price;
    if (price) card.querySelector('[data-pairing-price]').textContent = price;
    card.querySelector('[data-pairing-error]').textContent = '';
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-pairing-add]');
    if (!button || adding) return;
    event.preventDefault();
    event.stopPropagation();
    const card = button.closest('[data-atwill-pairing-card]');
    const select = card.querySelector('[data-pairing-variant]');
    if (!select.value) { select.focus(); return; }
    const error = card.querySelector('[data-pairing-error]');
    const config = document.querySelector('[data-atwill-pairings-messages]');
    const messages = config ? JSON.parse(config.textContent) : {};
    adding = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    error.textContent = '';
    let added = false;
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(select.value), quantity: 1 }] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || messages.error);
      added = true;
      const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error(messages.error);
      const cart = await cartResponse.json();
      document.dispatchEvent(new CustomEvent('product:add-to-cart:success', { detail: { cart, line_item: result } }));
      const drawer = window.Core?.Components?.getComponent('cart-drawer');
      const onCartPage = location.pathname.replace(/\/$/, '') === `${root}cart`.replace(/\/$/, '');
      if (drawer?.enabled && !onCartPage) {
        const trigger = document.querySelector('[data-header-cart-count]')?.closest('a') || button;
        await drawer.open(trigger, true, result.items);
      } else {
        location.assign(`${root}cart`);
      }
    } catch (problem) {
      if (added) { location.assign(`${root}cart`); return; }
      error.textContent = problem.message || messages.error;
    } finally {
      adding = false;
      button.disabled = !select.value;
      button.removeAttribute('aria-busy');
    }
  }, true);
})();
